export const full_partner_name = 'Corestaff services';
export const short_partner_name = 'CoreStaff';